<template>
  <div>
    <!-- 第一部分 -->
    <div class="banner">
      <img
        src="../assets/FURminator_banner01.png"
        alt=""
        style="vertical-align: middle; width: 100%"
      />
    </div>

    <div class="first_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">富美内特产品系列</span>
              <span class="title_en"> Product Range </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex j-sb">
        <div style="width: 600px; height: 600px">
          <img
            src="../assets/FURminator_banner02.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div class="d-flex" style="flex-direction: column">
          <div
            class="title_item d-flex a-center"
            style="background-color: #1262a3"
          >
            <div
              class="d-flex"
              style="
                flex-direction: column;
                padding: 0 30px;
                box-sizing: border-box;
              "
            >
              <strong
                style="font-size: 36px; letter-spacing: 0.04em; color: #fff"
                >祛毛梳:</strong
              >
              <span style="font-size: 26px; color: #fff; margin-top: 10px"
                >全球首创祛毛梳,欧美宠物美容师力荐</span
              >
            </div>
          </div>
          <div
            class="title_item d-flex a-center"
            style="background-color: #0dccbc"
          >
            <div
              class="d-flex"
              style="
                flex-direction: column;
                padding: 0 30px;
                box-sizing: border-box;
              "
            >
              <strong
                style="font-size: 36px; letter-spacing: 0.04em; color: #fff"
                >美容工具:</strong
              >
              <span style="font-size: 26px; color: #fff; margin-top: 10px"
                >适合美容师使用的全线产品</span
              >
            </div>
          </div>
          <div
            class="d-flex a-center"
            style="width: 560px; height: 180px; background-color: #ffca00"
          >
            <div
              class="d-flex"
              style="
                flex-direction: column;
                padding: 0 30px;
                box-sizing: border-box;
              "
            >
              <strong
                style="font-size: 36px; letter-spacing: 0.04em; color: #fff"
                >宠物香波:</strong
              >
              <span
                style="
                  font-size: 26px;
                  line-height: 1.5em;
                  color: #fff;
                  margin-top: 10px;
                "
                >宠物毛发护理 全线美国进口浴液 呵护宠物一身被毛</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 第二部分 -->
    <div class="second_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">了解祛毛工具 </span>
              <span class="title_en"> Product Description </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 900px">
          <img
            src="../assets/FURminator_banner03.jpg"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 800px; text-align: left; margin-top: 40px">
          <p style="font-size: 20px; color: #333; line-height: 2em">
            <strong style="font-size: 26px; color: #2963a4">
              祛毛是什么意思:</strong
            ><br />
            1.
            通常而言,人们在谈论到处理宠物脱毛时,会用到“刷毛”和/或“梳毛”这样的词语,但是,
            “刷毛”和“梳毛”并不等同于“祛毛”； <br />
            2. 人们用毛刷和毛梳给宠物梳毛,清除里面的杂质,保持宠物的漂亮形象；
            <br />
            3.
            使用祛毛工具,无需修剪或破坏宠物的表层毛,就能将其身上脱落的绒毛清理出来；
            <br />
            4.
            虽然一般的宠物美容流程包含了这两个必需的步骤,但就处理脱毛而论,富美内特®
            宠物祛毛工具的表现比任何毛刷、耙梳和毛梳更加出色。
            <br />
            <br />
            <strong style="font-size: 26px; color: #2963a4">
              祛毛是一般的宠物美容流程中的一个重要环节,原因在于:</strong
            ><br />
            1. 祛毛能够保持宠物良好的健康和卫生状况；<br />
            2. 对于猫和其它喜欢舔毛的小动物而言,减少毛球的形成；<br />
            3. 在祛毛的过程中,可以顺道对宠物进行全身检查；<br />
            4. 增强宠物和主人之间的感情。
          </p>
        </div>
      </div>
    </div>

    <!-- 第三部分 -->
    <div class="first_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">产品优势 </span>
              <span class="title_en"> Product Advantages</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 900px">
          <img
            src="../assets/FURminator_banner04.jpg"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 900px; text-align: left; margin-top: 40px">
          <div class="advantage_item">
              <span>
                获得专利的不锈钢祛毛边,可减少90%的脱毛。
              </span>
          </div>
          <div class="advantage_item">
              <span>
                由欧美专业美容师设计为宠物量身定制的祛毛工具。
              </span>
          </div>
          <div class="advantage_item">
              <span>
                效果显著,受到欧美宠物美容师以及宠物饲主的一致好评。
              </span>
          </div>
          <div class="advantage_item">
              <span>
                只要按下富美内特®按钮,就可以在祛毛梳上把脱毛清理干净,十分方便。
              </span>
          </div>
          <div class="advantage_item">
              <span>
                避免在猫和小动物体内形成毛球,且不会对宠物造成损伤。
              </span>
          </div>
          <div class="advantage_item">
              <span>
                值得信赖,口碑极佳：全世界的宠物美容师、兽医和宠物专家都推荐使用。
              </span>
          </div>
          <div class="advantage_item">
              <span>
                符合人体工程学的手柄让您用起来得心应手。
              </span>
          </div>
          <div class="advantage_item" style="margin-bottom: 0;">
              <span>
                精益求精工艺,任何山寨无法模仿。
              </span>
          </div>
        </div>
      </div>
    </div>

      <!-- 第四部分 -->
      <div class="second_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">爱犬祛毛工具 </span>
              <span class="title_en"> Hair Removal Tools</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 1000px">
          <img
            src="../assets/FURminator_banner05.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 1000px; text-align: left; margin-top: 30px">
          <p style="font-size: 20px; color: #333; line-height: 2em">
            · 有五种尺寸不同的工具。<br/>
            · 每种尺寸分别有长毛（毛层为2英寸或更长）和短毛（毛层短于2英寸）两种祛毛边。<br/>
            · 可以显著有效地减少脱毛。 <br/>
            · 您可能还不知道，只需花费相当于宠物美容一次的价钱，就可以买到一把又专业又方便的祛毛工具，
            自己在家里就能够改善宠物脱毛的现象。
          </p>
        </div>
      </div>
    </div>

    <!-- 第五部分 -->
    <div class="first_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">猫咪祛毛工具 </span>
              <span class="title_en"> Hair Removal Tools</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 1000px">
          <img
            src="../assets/FURminator_banner06.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 1000px; text-align: left; margin-top: 30px">
          <p style="font-size: 20px; color: #333; line-height: 2em">
            · 有两种尺寸不同的工具。<br/>
            · 每种尺寸分别有长毛（毛层为2英寸或更长）和短毛（毛层短于2英寸）两种祛毛边。<br/>
            · 可以显著有效地减少脱毛。 <br/>
            · 您可能还不知道，猫会在舔毛的时候，最多会咽下三分之二的毛。
            祛毛工具通过控制猫在舔毛时咽下的毛量，能够避免在猫体内形成毛球。
          </p>
        </div>
      </div>
    </div>

     <!-- 第六部分 -->
     <div class="second_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">如何为爱宠选祛毛梳 </span>
              <span class="title_en"> Pet Knowledge</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 1000px">
          <img
            src="../assets/FURminator_banner07.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 1000px;margin-top: 30px;">
          <img
            src="../assets/FURminator_banner08.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
       
      </div>
    </div>

    <!-- 底部栏 -->
    <foot></foot>

  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.w {
  width: 1200px;
  margin: 0 auto;
}

.d-flex {
  display: flex;
}
.a-center {
  align-items: center;
}
.j-sb {
  justify-content: space-between;
}
.j-center {
  justify-content: center;
}
.banner {
  width: 100%;
}
.first_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #f4f7fb;
}

.title {
  width: 1200px;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}
.titleBox {
  padding: 4px 0;
  //   border-bottom: 1px solid #2963a4;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  //   .title_num {
  //     font-size: 80px;
  //     font-weight: 500;
  //     color: #2963a4;
  //     margin-right: 5px;
  //   }
  .title_contain {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px 20px;
    border-bottom: 5px solid #2963a4;
    .title_intro {
      font-size: 46px;
      color: #333;
      font-weight: 600;
      text-align: center;
    }
    .title_en {
      font-size: 35px;
      letter-spacing: 0.02em;
      text-align: center;
      color: #999;
    }
  }
}

.second_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #fff;
}

.third_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #f4f7fb;
}

.title_item {
  width: 560px;
  height: 180px;
  margin-bottom: 30px;
}

.advantage_item{
    background-color: #1262a3;
    padding: 20px 30px;
    margin-bottom: 20px;
    color: #fff;
    font-size: 26px;
    font-weight: 600;
    letter-spacing: 1.2px;
    line-height: 1.5em;
}
</style>